import ObservacoesModal from '@components/Modals/Shared/ObservacoesModal/Index';
import { useState } from 'react';
import { useSelector } from 'react-redux';

export const ObservacoesHandler = ({ row, nomeItemProcesso }) => {

  const idProcessoItem = row.idProcessoItem;
  const idSolicitacao = row.idSolicitacao;

  const [visible, setVisible] = useState(false);

  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  const observacaoAtual = useSelector(
    (state) => state.observacoes.observacoesPorItem[row.idProcessoItem]
  );

  const hasObservacao = !!observacaoAtual;

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <i
          className="fs-6 fa-solid fa-edit"
          onClick={openModal}
          style={{ color: '#2b97be', cursor: 'pointer' }}
          title="Observações associadas ao item do processo"
        />

        <i
          className={`fa-solid ${hasObservacao ? 'fa-check text-success' : 'fa-minus text-muted'
            } fs-6`}
          style={{ opacity: 0.7, cursor: 'pointer' }}
          onClick={openModal}
          title={
            hasObservacao
              ? 'Há uma observação cadastrada'
              : 'Nenhuma observação cadastrada'
          }
        />

      </div>

      <ObservacoesModal
        visible={visible}
        idProcessoItem={idProcessoItem}
        idSolicitacao={idSolicitacao}
        existingObservacoes={observacaoAtual}
        nomeItemProcesso={nomeItemProcesso}
        closeModal={closeModal}
      />

    </>
  );
};

export default ObservacoesHandler;
